export const alertMessages = {
  vinculate: {
    title: 'Melhor envio desvinculado!',
    description:
      'Este é um recurso beta, você precisa estar vinculado ao Melhor Envio para oferecer esse tipo de frete.',
    buttonText: 'Vincular'
  },
  reactivate: {
    title: 'Melhor Envio expirado!',
    description: 'Você precisa reativar ao Melhor Envio para oferecer esse tipo de frete.',
    buttonText: 'Reativar'
  }
};

export const fieldHelpMessages = {
  weight: '',
  height: 'A altura não pode ser menor que 1cm ou maior que 100cm',
  width: 'A largura não pode ser menor que 1cm ou maior que 100cm',
  length: 'O comprimento não pode ser menor que 1cm ou maior que 100cm'
};
